import DismissButton from 'components/dismiss-button'

interface ConfirmationOverlayProps {
    title: string
    message: string
    confirmLabel?: string
    onConfirm: () => void
    onDismiss: () => void
    isLoading?: boolean
}

export const ConfirmationOverlay = ({
    title,
    message,
    confirmLabel = 'Confirm',
    onConfirm,
    onDismiss,
    isLoading = false,
}: ConfirmationOverlayProps) => {
    return (
        <div className="overlay">
            <div className="overlay-content-container">
                <div className="overlay-content-header">
                    <h3>{title}</h3>
                    <DismissButton onClick={onDismiss} />
                </div>
                <div className="overlay-content-body">
                    <p>{message}</p>
                    <div className="alignRight" style={{ gap: '12px', display: 'flex', justifyContent: 'flex-end', marginTop: '1.5rem' }}>
                        <button
                            onClick={onDismiss}
                            disabled={isLoading}
                            style={{ padding: '8px 16px', borderRadius: '6px', border: '1px solid #d1d5db', background: 'white', cursor: 'pointer' }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onConfirm}
                            disabled={isLoading}
                            style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', background: 'var(--blue)', color: 'white', cursor: 'pointer', fontWeight: 600 }}
                        >
                            {isLoading ? 'Please wait...' : confirmLabel}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
